import ViewUsers from './ViewUsers';
import ViewUsersHOC from './ViewUsersHOC';

export default ViewUsersHOC(ViewUsers);



// WEBPACK FOOTER //
// ./src/components/ViewUsers/index.jsx